import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Container, Title, Section, Button } from '../modules/modules';
import CountryService from '../services/CountryService';

interface INotFoundPageProps extends RouteComponentProps<{ language: string; orderNumber: string | undefined }> { }

class NotFoundPage extends React.Component<INotFoundPageProps> {

  render() {
    const { language } = CountryService.GetInstance();

    return (
      <main>
        <Section type="borderTop pt-10-force mb-6">
          <Container type="xs">
            <div className="text-center">
              <Title>
                Page not found
              </Title>
              <div className="text-error mt-2">#404</div>
              <div className="mt-5 mt-3-md">
                <Button
                  onClick={() =>
                    this.props.history.push(`/${language}/`)
                  }
                  color="trans"
                  size="lg"
                >
                  Go to homepage
                </Button>
              </div>
            </div>
          </Container>
        </Section>
      </main>
    );
  }
}

export default withRouter(NotFoundPage);



// WEBPACK FOOTER //
// ./src/pages/NotFound.tsx